export const Lst = [
  {
    _id: 1,
    Name: "Volvo",
    imgurl: "ProductImg/Virat.png",
    Technicalname: "Mycorrhizal Biofertilizer",
    Type: "Biofertilizer",
  },
  {
    _id: 2,
    Name: "Poshak",
    imgurl: "ProductImg/Poshak.png",
    TechnicalName: "Sulphur 90% WDG",
    Type: "Contact Fungicide",
    Crops: "Wheat, Paddy, Mango & Sugarcane",
    Packing: "500gm & 250gm.",
    Usage: "Controls leaf spot, rust diseases & blast disease of paddy crop",
  },
  {
    _id: 2,
    Name: "Sun Quit",
    imgurl: "ProductImg/SunQuit.png",
    TechnicalName: "Paraquate Dichloride 24% SL",
    Type: "Non-Selective Contact Herbicide",
    Crops: "Non crop area.",
    Packing: "1Ltr, 500ml, 250ml.",
    Usage: "controls weeds in many agricultural & non-agricultural settings.",
  },
];
